/**
 * @file
 * @author dailin01
 */
import Menu from './menu';
export default Menu;
